"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var R = _interopRequireWildcard(require("ramda"));

var VideoIntegrationConstants = _interopRequireWildcard(require("./videoIntegration.constants"));

var _video = require("./video.helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @param {*} fn
 * @returns {boolean}
 */
var isFunction = function isFunction(fn) {
  return R.type(fn) === 'Function';
};
/**
 * @param {object} props
 * @param {string} props.type
 * @param {string} props.vidyardVideo
 * @param {string} props.vidyardImage
 * @param {string} props.videoMessage
 * @param {boolean} props.isLoading
 * @param {object.<string, string>} props.errors
 * @param {function (): void} props.onSave
 * @param {function (): void} props.onUpdateErrors
 * @param {function (): void} props.onChangeType
 * @param {function (): void} props.onAfterVideoMessageChange
 * @param {function (): void} props.onAfterVidyardVideoSelect
 * @returns {object}
 */


var useVideoIntegration = function useVideoIntegration(_ref) {
  var type = _ref.type,
      vidyardVideo = _ref.vidyardVideo,
      vidyardImage = _ref.vidyardImage,
      videoMessage = _ref.videoMessage,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? {} : _ref$errors,
      onSave = _ref.onSave,
      onUpdateErrors = _ref.onUpdateErrors,
      _ref$onChangeType = _ref.onChangeType,
      onChangeType = _ref$onChangeType === void 0 ? null : _ref$onChangeType,
      _ref$onAfterVideoMess = _ref.onAfterVideoMessageChange,
      onAfterVideoMessageChange = _ref$onAfterVideoMess === void 0 ? null : _ref$onAfterVideoMess,
      _ref$onAfterVidyardVi = _ref.onAfterVidyardVideoSelect,
      onAfterVidyardVideoSelect = _ref$onAfterVidyardVi === void 0 ? null : _ref$onAfterVidyardVi;

  var _useState = (0, _react.useState)(videoMessage),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      localVideoMessage = _useState2[0],
      setLocalVideoMessage = _useState2[1];

  var _useState3 = (0, _react.useState)(vidyardVideo),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      localVidyardVideo = _useState4[0],
      setLocalVidyardVideo = _useState4[1];

  var _useState5 = (0, _react.useState)(vidyardImage),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      localVidyardImage = _useState6[0],
      setLocalVidyardImage = _useState6[1];

  var _useState7 = (0, _react.useState)(type),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      localType = _useState8[0],
      setLocalType = _useState8[1];

  var hasErrors = !!errors.recipient_video || !!errors.vidyard_video || !!errors.vidyard_image;
  var isSaveDisable = localType !== VideoIntegrationConstants.VIDEO_TYPE_DISABLED && (isLoading || hasErrors);
  var handleVideoEnabled = (0, _react.useCallback)(function (_ref2) {
    var value = _ref2.target.value;
    setLocalType(value);

    if (isFunction(onChangeType)) {
      onChangeType({
        typeValue: value,
        videoMessageValue: localVideoMessage,
        vidyardImageValue: localVidyardImage,
        vidyardVideoValue: localVidyardVideo
      });
    }
  }, [onChangeType, localVideoMessage, localVidyardImage, localVidyardVideo]);
  var handleVidyardSelect = (0, _react.useCallback)(function (value) {
    var thumbnail = "https:".concat(value.thumbnail);
    var baseUrl = "https:".concat(value.base_url);
    setLocalVidyardImage(thumbnail);
    setLocalVidyardVideo(baseUrl);
    onUpdateErrors({});

    if (isFunction(onAfterVidyardVideoSelect)) {
      onAfterVidyardVideoSelect({
        typeValue: localType,
        videoMessageValue: localVideoMessage,
        vidyardImageValue: thumbnail,
        vidyardVideoValue: baseUrl
      });
    }
  }, [setLocalVidyardVideo, localType, setLocalVidyardImage, localVideoMessage, onAfterVidyardVideoSelect, onUpdateErrors]);
  var handleVidyardRemove = (0, _react.useCallback)(function () {
    setLocalVidyardImage(null);
    setLocalVidyardVideo(null);
    onUpdateErrors({});
  }, [setLocalVidyardVideo, setLocalVidyardImage, onUpdateErrors]);
  var updateVideoMessageErrors = (0, _react.useCallback)(function () {
    var errorsValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var saveErrors = errorsValue === null ? {} : {
      recipient_video: [errorsValue]
    };
    onUpdateErrors(saveErrors);
  }, [onUpdateErrors]);
  var handleSetLocalVideoMessage = (0, _react.useCallback)(function (_ref3) {
    var value = _ref3.target.value;
    setLocalVideoMessage(value);
    updateVideoMessageErrors();

    if (!value && !localType) {
      updateVideoMessageErrors();
      return;
    }

    var validationError = (0, _video.getVideoValidationError)(value, localType);

    if (validationError) {
      updateVideoMessageErrors(validationError);
      return;
    }

    if (isFunction(onAfterVideoMessageChange)) {
      onAfterVideoMessageChange({
        typeValue: localType,
        videoMessageValue: value,
        vidyardImageValue: localVidyardImage,
        vidyardVideoValue: localVidyardVideo
      });
    }
  }, [updateVideoMessageErrors, localType, localVidyardImage, localVidyardVideo, onAfterVideoMessageChange]);
  var handleSave = (0, _react.useCallback)(function () {
    var additionalPayloadParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var payload = _objectSpread({
      videoMessageValue: localVideoMessage,
      vidyardImageValue: localVidyardImage,
      vidyardVideoValue: localVidyardVideo,
      typeValue: localType
    }, additionalPayloadParams);

    onSave(payload);
  }, [localVideoMessage, localVidyardImage, localVidyardVideo, localType, onSave]);
  (0, _react.useEffect)(function () {
    if (localType === VideoIntegrationConstants.VideoType.EMBED) {
      var validationError = (0, _video.getVideoValidationError)(localVideoMessage, localType);
      updateVideoMessageErrors(validationError);
    }
  }, [localType, localVideoMessage, updateVideoMessageErrors]);
  return {
    videoType: localType,
    videoMessage: localVideoMessage,
    vidyardVideo: localVidyardVideo,
    vidyardImage: localVidyardImage,
    isSaveDisable: isSaveDisable,
    handleVideoEnabled: handleVideoEnabled,
    handleVidyardSelect: handleVidyardSelect,
    handleVidyardRemove: handleVidyardRemove,
    handleSetLocalVideoMessage: handleSetLocalVideoMessage,
    handleSave: handleSave
  };
};

var _default = useVideoIntegration;
exports["default"] = _default;